<template>
    <div class="TQ_center">
        <tq-card margin="16px" padding="16px">

            <!-- 1) users table-->
            <div class="TQ_border TQ_borderRadius TQ_padding_8px TQ_bg_gray4">

                <!-- 1) table -->
                <tq-table
                        class="TQ_bg_white TQ_padding_8px  "
                        :rows="usersData_ac"
                        :system-lang-code="store_system_langCode_ve.val"
                        :display-search="true"
                        p_td-classes_s="TQ_padding_8px TQ_maxWidth_300px TQ_textAlign_initial"
                        :columns="[
                    {label : 'Creation Time',       field : (row) => {return format_date_YYYY_MM_DD_hh_mm_fs(row.ud_creationTime_t)}},
                    {label : 'Id',                  field : (row) => {return row.ud_userId_uid}},
                    {label : 'Login Methods',       field : (row) => {return row.ud_loginMethods_ae}},
                    {label : 'Email',               field : (row) => {return row.ud_email_s}},
                    {label : 'Name',                field : (row) => {return row.ud_name_s}},
                    {label : 'Access Level',        field : (row) => {return row.ud_accessLevel_n},},
                    {label : 'Editable Quests Ids', field : m_dom_getUserCreatedQuests},
                    {label : 'Tickets Ids',         field : m_dom_getUserQuestsTickets},
                ]"
                        :p_actions_ao="[
                            {label_byLangCode : ass_strings.oneWord_edit,    action_f : m_editPlayer_f,   class : 'TQ_bg_gold'},
                            {label_byLangCode : ass_strings.oneWord_permissions,    action_f : m_showAddPermissionPopUp_f,   class : 'TQ_bg_gold'},
                        ]"
                />

                <!-- 3) btn -->
                <hr>
                <div >
                    <tq-loader-button btn-class="TQ_btn TQ_bg_green TQ_borderRadius TQ_text_24px"
                                      class="TQ_margin_8px"
                                      text="Get Users"
                                      :show-loader="showBtnLoader"
                                      @clickBtn="m_getUsersData_f()">
                    </tq-loader-button>

                    <!--<div class="TQ_padding_8px" @click="m_downloadUsers_f">-->
                    <!--Download-->
                    <!--</div>-->


                    <tq-loader-button btn-class="TQ_btn TQ_bg_gold TQ_borderRadius TQ_text_24px"
                                      class="TQ_margin_8px"
                                      text="Get online Users"
                                      :show-loader="showBtnLoader"
                                      @clickBtn="m_getOnlineUsersData_f()">
                    </tq-loader-button>
                </div>
            </div>

            <!-- 2) space-->
            <div class="TQ_padding_16px" v-if="selected_userData_new_c"></div>

            <!-- 2) player actions -->
            <div v-if="selected_userData_new_c" class="TQ_border TQ_padding_8px TQ_box_shadow TQ_borderRadius TQ_bg_gray4">

                <div class="TQ_text_24px TQ_text_bold TQ_text_capitalize">
                    Edit User
                </div>
                <hr>

                <!-- user basic info-->
                <table class="TQ_center">

                    <tr class="TQ_bg_gray1">
                        <th>name</th>
                        <th>email</th>
                        <th>userId</th>
                        <th>accessLevel</th>
                        <th>tq profit percentage</th>
                    </tr>
                    <tr>
                        <td>{{selected_userData_new_c.ud_name_s}}</td>
                        <td>{{selected_userData_new_c.ud_email_s}}</td>
                        <td>{{selected_userData_new_c.ud_userId_uid}}</td>
                        <td>
                            <input v-model.number="selected_userData_new_c.ud_accessLevel_n" class="TQ_center TQ_width_100px TQ_borderBox TQ_padding_4px"/>
                        </td>
                        <td>
                            <input v-model.number="selected_userData_new_c.ud_tqProfitPercentage_n" class="TQ_center TQ_width_100px TQ_borderBox TQ_padding_4px"/>
                        </td>
                    </tr>

                </table>

                <!-- user lang code-->
                <div v-if="selected_userMoreInfo_new_c" class="TQ_padding_16px TQ_grid_col_auto1fr TQ_maxWidth_300px TQ_center TQ_grid_gap_8px">

                    <!-- main lang -->
                    <div class="TQ_grid_verticalCenter TQ_text_bold"> main lang  </div>
                    <tq-dropdown class="TQ_bg_white TQ_width_100px TQ_grid_verticalCenter"
                                 :style-select="true">
                        <div slot="select" >
                            {{format_langCode_fs(selected_userMoreInfo_new_c.udsmi_mainLang_e)}}
                        </div>

                        <div    slot="options"
                                @click="m_updateQuestMainLang_f(langCode)"
                                v-for="langCode in selected_userMoreInfo_new_c.udsmi_langArr_ae">
                            {{format_langCode_fs(langCode)}}
                        </div>
                    </tq-dropdown>

                    <!-- lang arr -->
                    <div class="TQ_grid_verticalCenter TQ_text_bold"> lang arr </div>
                    <div class="TQ_align_initial">
                        {{selected_userMoreInfo_new_c.udsmi_langArr_ae}}
                    </div>

                    <!-- add lang-->
                    <div class="TQ_grid_verticalCenter TQ_text_bold"> add lang </div>
                    <div class="TQ_align_initial TQ_grid_verticalCenter">
                        <tq-dropdown class="TQ_margin_4px TQ_width_100px TQ_bg_white TQ_center"
                                     :style-select="true">

                            <div slot="select" >
                                {{format_langCode_fs(selectedNewLangCode)}}
                            </div>

                            <div    slot="options"
                                    @click="selectedNewLangCode = langCode"
                                    v-for="langCode in enum_langCodes">
                                {{format_langCode_fs(langCode)}}
                            </div>
                        </tq-dropdown>
                        <div class="TQ_btn TQ_margin_4px TQ_bg_green"
                             v-if="!selected_userMoreInfo_new_c.udsmi_langArr_ae.includes(selectedNewLangCode)"
                             @click="selected_userMoreInfo_new_c.udsmi_langArr_ae.push(selectedNewLangCode)">
                            {{ass_strings.oneWord_add[store_system_langCode_ve.val]}}
                        </div>
                        <div class="TQ_btn TQ_margin_4px TQ_bg_red"
                             v-else
                             @click="m_user_removeLangCode_f()">
                            {{ass_strings.oneWord_delete[store_system_langCode_ve.val]}}
                        </div>
                    </div>

                </div>

                <hr>

                <table class="TQ_center TQ_text_12px">

                    <tr class="TQ_bg_gray1">
                        <th>#</th>
                        <th>questId</th>
                        <th>questType</th>
                        <th>&</th>
                    </tr>
                    <tr v-for="(questPointer_c, questId_uid, index_n) in selected_userCreateQuests_byQuestId_c" :key="questId_uid">
                        <td>{{index_n + 1}}</td>
                        <td>{{questPointer_c.qp_questId_uid}}</td>
                        <td>{{questPointer_c.qp_questType_e}}</td>
                        <td>
                            <img :src="ass_img_garbage_w"  class="TQ_padding_4px TQ_bg_red TQ_width_16px TQ_borderRadius" @click="() => {$delete(selected_userCreateQuests_byQuestId_c, questId_uid)}"/>
                        </td>
                    </tr>

                    <tr>
                        <td> </td>
                        <td> <input class="TQ_width_100p TQ_padding_4px TQ_borderBox TQ_center" placeholder="questId" v-model="newQuestPointer_questId_s"/></td>
                        <td> <input class="TQ_width_100p TQ_padding_4px TQ_borderBox TQ_center" placeholder="questType" v-model="newQuestPointer_questType_s"/></td>
                        <td>
                            <img :src="ass_img_add_w"  class="TQ_padding_4px TQ_bg_green TQ_width_16px TQ_borderRadius" @click="m_addNewQuestPointer_f"/>
                        </td>
                    </tr>

                </table>

                <hr>

                <!-- update button -->
                <tq-btn-approve
                        v-if="co_changeUserData_b || co_changeUserCreateQuests_b || co_changeUserMoreInfo_b"
                        class="TQ_inline "
                        btn-class="TQ_btn TQ_text_bold TQ_bg_gold TQ_margin_4px TQ_text_capitalize TQ_borderRadius TQ_text_20px"
                        :system-lang-code="store_system_langCode_ve.val"
                        :text="ass_strings.oneWord_save"
                        :popup-text="ass_strings.question_updateUser"
                        :approve-cb="m_updateUser_f">
                </tq-btn-approve>

                <!-- delete user-->
                <tq-btn-approve
                        class="TQ_inline "
                        btn-class="TQ_btn TQ_text_bold TQ_bg_red TQ_margin_4px TQ_text_capitalize TQ_borderRadius TQ_text_20px"
                        :system-lang-code="store_system_langCode_ve.val"
                        :text="ass_strings.oneWord_delete"
                        :popup-text="ass_strings.question_deleteUser"
                        :approve-cb="() => { } ">
                </tq-btn-approve>



            </div>

        </tq-card>

        <tq-popup :show="addUSerPermission_o.showPopUp_vb" max-width="350px" padding="8px">
            <div>
                {{ass_strings.twoWords_userAccess[store_system_langCode_ve.val]}}
            </div>
            <hr>
            <input placeholder="userId" v-model="addUSerPermission_o.userId_uid" disabled class="TQ_width_100p TQ_padding_8px TQ_borderBox TQ_center"/>
            <div class="TQ_padding_4px"></div>
            <input placeholder="questType" v-model="addUSerPermission_o.questType_e" class="TQ_width_100p TQ_padding_8px TQ_borderBox TQ_center"/>
            <div class="TQ_padding_4px"></div>
            <input placeholder="questId_uid" v-model="addUSerPermission_o.questId_uid" class="TQ_width_100p TQ_padding_8px TQ_borderBox TQ_center"/>
            <div class="TQ_padding_4px"></div>
            <input placeholder="permissionLevel" v-model.number="addUSerPermission_o.permissionLevel_n" class="TQ_width_100p TQ_padding_8px TQ_borderBox TQ_center"/>

            <hr>
            <div class="TQ_grid_col_Auto1frAuto">
                <div @click="addUSerPermission_o.showPopUp_vb.val=false" class="TQ_padding_8px TQ_bg_gray4 TQ_box_shadow TQ_borderRadius">{{ass_strings.oneWord_cancel[store_system_langCode_ve.val]}}</div>
                <div></div>
                <div @click="m_addPermissionToUser_f" class="TQ_padding_8px TQ_bg_purple TQ_box_shadow TQ_borderRadius">{{ass_strings.oneWord_approve[store_system_langCode_ve.val]}}</div>
            </div>
        </tq-popup>
    </div>
</template>

<script>
    import TqCard from "../../components/basic/TqCard";
    import TqTable from "../../components/basic2/TqTable";
    import TqPopup from "../../components/basic/TqPopup";
    import TqBtnApprove from "../../components/basic2/TqBtnApprove";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqLoaderButton from "../../components/basic2/TqLoaderButton";
    import {format_date_YYYY_MM_DD_hh_mm_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import {enum_accessLevelOptions, enum_langCodes} from "../../../functions/src/shareCode/Share_S_Enum"
    import {obj_deepCopy_f, obj_forEach_f, obj_equals_fb} from "../../../functions/src/shareCode/Share_S_Obj";
    import {format_langCode_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import {
        FB_QuestPointer,
        FB_UserData,
        FB_UserDataSub_MoreInfo
    } from "../../../functions/src/shareCode/Share_S_Classes";
    import {ass_img_add_w, ass_img_garbage_w} from "../../assets/scripts/Ass_Files";
    import {
        serverPre_subUserData_moreInfo_get_f,
        serverPre_subUserData_moreInfo_update_f,
        serverPre_allUsersCreatedQuests_getOnce_fp,
        serverPre_userDataSub_questPermission_set_f,
        serverPre_subUserData_creatorPaymentInfo_get_f,
        serverPre_userDataSub_onlineUsers_getAll,
    } from "../../scripts/Server/S_ServerPre";
    import {store_getStateValue_vo, store_var} from "../../store";
    import {
        serverAuth_getAllUsers_f, serverAuth_getOtherUserData_f,
        serverAuth_updateUserAccessLevel_fp,
        serverAuth_userData_email_update_f
    } from "../../scripts/Server/S_ServerAuth";
    import {notification_notify, notification_notify2} from "../../scripts/S_Notification";
    import TqDropdown from "../../components/basic/TqDropdown";

    export default {
        name: "v_Admin_Manage_Players",
        components: {TqDropdown, TqLoaderButton, TqBtnApprove, TqPopup, TqTable, TqCard},
        data(){
            return {

                // users data
                usersData_ac: [],
                oldUserData_byUserId_c : {},
                usersCreatedQuest_byUserId_byQuestId_c: {},
                usersQuestsTickets_byUserId_c: [],
                selectedNewLangCode: enum_langCodes.hebrew,

                addUSerPermission_o :{
                    showPopUp_vb: {val : false},
                    userId_uid: null,
                    questId_uid: null,
                    questType_e: null,
                    permissionLevel_n: null,
                },

                // editPlayer
                selected_userData_c  : null,
                selected_userData_new_c  : null,
                selected_userCreateQuests_byQuestId_c  : null,
                selected_userMoreInfo_new_c  : null,
                selected_userMoreInfo_c  : null,
                newQuestPointer_questId_s    : "",
                newQuestPointer_questType_s  : "",

                //
                showBtnLoader: false,

                // imports
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),
                ass_strings: ass_strings,
                format_date_YYYY_MM_DD_hh_mm_fs: format_date_YYYY_MM_DD_hh_mm_fs,
                ass_img_garbage_w: ass_img_garbage_w,
                ass_img_add_w: ass_img_add_w,
                format_langCode_fs: format_langCode_fs,
                enum_langCodes: enum_langCodes,
            }
        },
        computed : {
            co_changeUserData_b(){
                return this.selected_userData_new_c.ud_accessLevel_n !== this.selected_userData_c.ud_accessLevel_n
            },
            co_changeUserCreateQuests_b(){
                return!obj_equals_fb(this.selected_userCreateQuests_byQuestId_c, this.usersCreatedQuest_byUserId_byQuestId_c[this.selected_userData_new_c.ud_userId_uid])
            },
            co_changeUserMoreInfo_b(){
                return!obj_equals_fb(this.selected_userMoreInfo_new_c, this.selected_userMoreInfo_c)
            },
        },
        methods:{

            // get users data
            m_getUsersData_f(){
                this.usersData_ac = []
                this.oldUserData_byUserId_c = {}

                serverAuth_getAllUsers_f((userData_c)=>{

                    this.usersData_ac.push(userData_c)
                    this.oldUserData_byUserId_c[userData_c.ud_userId_uid] = obj_deepCopy_f(userData_c);

                })

            },
            m_getOnlineUsersData_f(){
                this.usersData_ac = []
                this.oldUserData_byUserId_c = {}

                serverPre_userDataSub_onlineUsers_getAll((onlineUsers_byUid_c) => {
                    for(let userId_uid in onlineUsers_byUid_c){
                        serverAuth_getOtherUserData_f(userId_uid, (userData_c) => {
                            this.usersData_ac.push(userData_c)
                            this.oldUserData_byUserId_c[userData_c.ud_userId_uid] = obj_deepCopy_f(userData_c);
                        })
                    }
                })
            },
            m_updateAllUsersEmails_f(userData_c){
                let userEmailLowerSplit_as = userData_c.ud_email_s.toLowerCase().split('@')


                let userEmailLower_s = `${userEmailLowerSplit_as[0].replace(/\./g, "")}@${userEmailLowerSplit_as[1]}`

                if(userEmailLower_s !== userData_c.ud_email_s){
                    console.log(userEmailLower_s, userData_c.ud_email_s)

                    userData_c.ud_email_s = userEmailLower_s
                    serverAuth_userData_email_update_f(userData_c, () => {})
                }

            },
            m_dom_getUserQuestsTickets(row){
                return this.usersQuestsTickets_byUserId_c[row.ud_userId_uid] ? Object.keys(this.usersQuestsTickets_byUserId_c[row.ud_userId_uid].uqt_ticketsIds_ByTicketId) : null
            },
            m_dom_getUserCreatedQuests(userData_c){

                let ans = ""
                if(this.usersCreatedQuest_byUserId_byQuestId_c[userData_c.ud_userId_uid] != null) {
                    obj_forEach_f(this.usersCreatedQuest_byUserId_byQuestId_c[userData_c.ud_userId_uid], (questPointer_c) => {
                        ans += questPointer_c.qp_questId_uid + "_" + questPointer_c.qp_questType_e + " "
                    })
                }
                return ans
            },

            // edit selected user
            m_editPlayer_f(userData_c){

                this.selected_userData_c = userData_c;
                this.selected_userData_new_c = new FB_UserData(obj_deepCopy_f(userData_c))

                this.selected_userCreateQuests_byQuestId_c = {}

                serverPre_subUserData_moreInfo_get_f({
                    userId_uid:userData_c.ud_userId_uid,
                    cb_f : (userMoreInfo_c) => {
                        this.selected_userMoreInfo_new_c = userMoreInfo_c
                        this.selected_userMoreInfo_c = new FB_UserDataSub_MoreInfo(obj_deepCopy_f(userMoreInfo_c))
                    }
                })

                serverPre_subUserData_creatorPaymentInfo_get_f({
                    userId_uid:userData_c.ud_userId_uid,
                    cb_f : (usd_paymentInfo_c) => {
                        console.log(usd_paymentInfo_c)
                    }
                })
            },
            m_addNewQuestPointer_f(){
                let questPointer_c = new FB_QuestPointer({
                    qp_questId_uid : this.newQuestPointer_questId_s,
                    qp_questType_e : this.newQuestPointer_questType_s
                })

                this.$set(this.selected_userCreateQuests_byQuestId_c, this.newQuestPointer_questId_s, questPointer_c);

                this.newQuestPointer_questId_s = ""
                this.newQuestPointer_questType_s = ""
            },
            m_updateUser_f(){

                // update permission
                if(this.co_changeUserData_b && Object.values(enum_accessLevelOptions).includes(this.selected_userData_new_c.ud_accessLevel_n)){

                    this.selected_userData_c.ud_accessLevel_n = this.selected_userData_new_c.ud_accessLevel_n

                    serverAuth_updateUserAccessLevel_fp(this.selected_userData_new_c).then( () => {
                        notification_notify(ass_strings.oneWord_saved)
                    })
                }


                if(this.co_changeUserMoreInfo_b){

                    this.selected_userMoreInfo_c = new FB_UserDataSub_MoreInfo(obj_deepCopy_f(this.selected_userMoreInfo_new_c))

                    serverPre_subUserData_moreInfo_update_f(
                        this.selected_userMoreInfo_new_c,
                        () => {
                            notification_notify(ass_strings.oneWord_updated)
                        }
                    )

                }

            },
            m_user_removeLangCode_f(){
                let index_n = this.selected_userMoreInfo_new_c.udsmi_langArr_ae.indexOf(this.selectedNewLangCode)
                this.selected_userMoreInfo_new_c.udsmi_langArr_ae.splice(index_n,1)
            },

            m_showAddPermissionPopUp_f(userData_c){
                this.addUSerPermission_o.showPopUp_vb.val = true
                this.addUSerPermission_o.userId_uid = userData_c.ud_userId_uid
            },
            m_addPermissionToUser_f(){

                if(this.addUSerPermission_o.questType_e === null || this.addUSerPermission_o.questId_uid === null || this.addUSerPermission_o.userId_uid === null || this.addUSerPermission_o.permissionLevel_n === null){
                    return
                }

                serverPre_userDataSub_questPermission_set_f({
                    questType_e: this.addUSerPermission_o.questType_e,
                    questId_uid: this.addUSerPermission_o.questId_uid,
                    userId_uid: this.addUSerPermission_o.userId_uid,
                    permissionLevel_n: this.addUSerPermission_o.permissionLevel_n,
                    cb_f: () => {
                        notification_notify2({title_s: ass_strings.oneWord_permissions[this.store_system_langCode_ve.val]})
                    },
                })
            },

            // others
            m_downloadUsers_f(){

                let exportObj = []
                this.usersData_ac.forEach(userData_c => {
                    exportObj.push({email : userData_c.ud_email_s})
                })

                let exportName = 'players emails'

                let dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
                let downloadAnchorNode = document.createElement('a');
                downloadAnchorNode.setAttribute("href",     dataStr);
                downloadAnchorNode.setAttribute("download", exportName + ".json");
                document.body.appendChild(downloadAnchorNode); // required for firefox
                downloadAnchorNode.click();
                downloadAnchorNode.remove();

            },
            m_initPermissions_f(){

                serverPre_allUsersCreatedQuests_getOnce_fp((questPointer_byUserId_byQuestId_o) => {

                    obj_forEach_f(questPointer_byUserId_byQuestId_o, (questPointer_byQuestId_o, userId_uid) => {
                        obj_forEach_f(questPointer_byQuestId_o, (questPointer_o, questId) => {

                            serverPre_userDataSub_questPermission_set_f({
                                questId_uid : questPointer_o.qp_questId_uid,
                                questType_e : questPointer_o.qp_questType_e,
                                userId_uid : userId_uid,
                                permissionLevel_n : 10,
                                cb_f: (res) => {
                                    console.log(res)
                                }
                            })
                        })
                    })
                })
            }

        },
        created(){
            // this.m_initPermissions_f()

            function* iteratorFunc() {
                let count = 0;
                for (let i = 0; i < 2; i++) {
                    count++;
                    yield i;
                }
                return count;
            }

            let iterator = iteratorFunc();
            console.log(iterator.next()); // {value:0,done:false}
            console.log(iterator.next()); // {value:1,done:false}
            console.log(iterator.next()); // {value:2,done:true}

        }
    }
</script>

<style scoped lang="scss">


    table,th,tr,td{
        border: 1px solid black;
        border-collapse: collapse;
        padding: 8px;
    }
</style>